import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AutocompleteLeadInjectorIdSuggestionService } from 'src/app/shared/common-features/services/autocomplete-strategies/autocomplete-lead-injector-id-suggestion.service';
import { SearchSuggestion } from '../../inputs/autocomplete/search-strategy-base';
import { LeadInjectorService } from 'src/app/features/lead-injector/services/lead-injector.service';
import { finalize, of, switchMap, tap } from 'rxjs';
import { GlobalSpinnerActions } from '../../global-spinner/actions-types';
import { FormControl } from '@angular/forms';
import { ImportLeadsFromFileService, UploadLeadsFileResult } from './import-leads-from-file.service';
import { SnackbarNotificationService } from '../../notifications/snackbar-notification/snackbar-notification.service';
import { LobbyErrorCode } from 'src/app/infrastructure/lobby-proxy/enums/lobby-error-code.enum';
import { LeadActions } from 'src/app/core/events/lead.actions';

@Component({
    selector: 'app-import-leads-from-file-dialog',
    templateUrl: './import-leads-from-file-dialog.component.html',
    styleUrls: ['./import-leads-from-file-dialog.component.scss'],
    standalone: false
})
export class ImportLeadsFromFileDialogComponent {

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef

  injectorForm = new FormControl<SearchSuggestion | null>(null)

  isFileLoaded = false

  file: File | undefined
  expectedLeadsCount: number | undefined
  uploadResult: UploadLeadsFileResult | undefined

  readonly fileExtentions: string[] = ['.xls', '.xlsx', '.csv']
  readonly fileTypes: string[] = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv']

  lobbyErrorCode = LobbyErrorCode

  private _injectorId: number | null = null

  constructor(private readonly appStore: Store,
    public injectorIdSuggestionService: AutocompleteLeadInjectorIdSuggestionService,
    public dialogRef: MatDialogRef<ImportLeadsFromFileDialogComponent>,
    private readonly leadInjectorService: LeadInjectorService,
    private readonly importLeadsFromFileService: ImportLeadsFromFileService,
    private readonly snackbarNotificationService: SnackbarNotificationService) {

  }

  onSearchFileClick() {
    this.fileInput?.nativeElement.click()
  }

  onFileDropped(files: FileList) {
    if (files?.length) this.loadFile(files[0])
    else this.snackbarNotificationService.openError("File non conforme")
  }

  onFileSelected(e: EventTarget) {
    const files: FileList = (e as any).files

    if (files?.length) this.loadFile(files[0])
    else this.snackbarNotificationService.openError("File non conforme")
  }

  onUploadClick() {
    of(void 0).pipe(
      tap(() => this.appStore.dispatch(GlobalSpinnerActions.showGlobalSpinner())),
      switchMap(() => this.importLeadsFromFileService.uploadFile$(this.file!, this._injectorId)),
      tap(result => this.uploadResult = result),
      tap(result => this.appStore.dispatch(LeadActions.leadsImported(result.successfullyCreatedLeadsCount))),
      finalize(() => this.appStore.dispatch(GlobalSpinnerActions.hideGlobalSpinner()))
    ).subscribe()
  }

  onSelectedInjectorSuggestion(suggestion: SearchSuggestion | null) {
    if (suggestion)
      this.leadInjectorService.getLeadInjector$(Number(suggestion?.id!)).pipe(
        tap(() => this.appStore.dispatch(GlobalSpinnerActions.showGlobalSpinner())),
        tap(injector => this._injectorId = injector.id),
        tap(() => this.appStore.dispatch(GlobalSpinnerActions.hideGlobalSpinner()))
      ).subscribe()
    else
      this._injectorId = null
  }

  onLoadAgainButtonClick() {
    this.isFileLoaded = false

    this.file = undefined
    this.expectedLeadsCount = undefined
    this.uploadResult = undefined
  }

  private loadFile(file: File) {
    this.file = file
    this.isFileLoaded = true
    console.log('file', file)

  }



  static createConfigurations(): MatDialogConfig {
    return {
      data: null,
      autoFocus: false
    }
  }

}
